module.exports = __webpack_public_path__ + "img/review_Illustration.58b19d8a.svg";